export const multiData = [
  {
    id: 859,
    brand: "nyx",
    name: "Epic Ink Lip Dye",
    price: "7.0",
    price_sign: "$",
    currency: "USD",
    image_link:
      "https://www.nyxcosmetics.com/dw/image/v2/AANG_PRD/on/demandware.static/-/Sites-cpd-nyxusa-master-catalog/default/dw7d8fe312/ProductImages/2017/Lips/Epic_Ink_Lip_Dye/epicinklipdye_main.jpg?sw=390&sh=390&sm=fit",
    product_link:
      "https://www.nyxcosmetics.com/epic-ink-lip-dye/NYX_397.html?cgid=lipgloss",
    website_link: "https://www.nyxcosmetics.com",
    description:
      "Drench your kiss in knockout color! A stroke of Epic Ink Lip Dye coats lips with a downright dramatic stain. Super-saturated and lightweight, our formula dries to a Matte finish. This stunning lip dye is an absolute makeup bag must-have. Rock it alone for an effortlessly vibrant look. Or give your favorite lippies a boost by wearing it under a similar shade!",
    rating: null,
    category: "lip_gloss",
    product_type: "lipstick",
    tag_list: [],
    created_at: "2017-12-24T02:26:12.842Z",
    updated_at: "2017-12-24T02:26:13.312Z",
    product_api_url:
      "https://makeup-api.herokuapp.com/api/v1/products/859.json",
    api_featured_image:
      "//s3.amazonaws.com/donovanbailey/products/api_featured_images/000/000/859/original/open-uri20171224-4-1jzc6ty?1514082372",
    product_colors: [
      {
        hex_value: "#C20201",
        colour_name: "Poised",
      },
      {
        hex_value: "#B60E0E",
        colour_name: "Blazed",
      },
      {
        hex_value: "#8E1325",
        colour_name: "Fresh",
      },
      {
        hex_value: "#710906",
        colour_name: "Slay",
      },
      {
        hex_value: "#69131C",
        colour_name: "Wizardry",
      },
      {
        hex_value: "#AF0A2C",
        colour_name: "Charmer",
      },
      {
        hex_value: "#AF0C45",
        colour_name: "Heartbreaker",
      },
      {
        hex_value: "#7A1B53",
        colour_name: "Obsessed",
      },
      {
        hex_value: "#7B1B40",
        colour_name: "Victorian",
      },
      {
        hex_value: "#4C091A",
        colour_name: "Nightrunner",
      },
      {
        hex_value: "#572316",
        colour_name: "Invasion",
      },
      {
        hex_value: "#E9361F",
        colour_name: "Revolt",
      },
    ],
  },
  {
    id: 858,
    brand: "nyx",
    name: "Strictly Vinyl Lip Gloss",
    price: "8.0",
    price_sign: "$",
    currency: "USD",
    image_link:
      "https://www.nyxcosmetics.com/dw/image/v2/AANG_PRD/on/demandware.static/-/Sites-cpd-nyxusa-master-catalog/default/dwd10df14c/ProductImages/2018/Lips/Strictly_Vinyl_Lip_Gloss/strictlyvinyllipgloss_main.jpg?sw=390&sh=390&sm=fit",
    product_link:
      "https://www.nyxcosmetics.com/strictly-vinyl-lip-gloss/NYX_592.html?cgid=lipgloss",
    website_link: "https://www.nyxcosmetics.com",
    description:
      "Strictly Vinyl Lip Gloss is music to our lips! Available in eight plush and pigment packed shades, this beyond glossy lippie is no one-hit wonder. Hardcore color and intense shine is always just a few swipes away.",
    rating: null,
    category: "lip_gloss",
    product_type: "lipstick",
    tag_list: [],
    created_at: "2017-12-24T02:25:57.181Z",
    updated_at: "2017-12-24T02:25:57.647Z",
    product_api_url:
      "https://makeup-api.herokuapp.com/api/v1/products/858.json",
    api_featured_image:
      "//s3.amazonaws.com/donovanbailey/products/api_featured_images/000/000/858/original/open-uri20171224-4-7z9c9k?1514082356",
    product_colors: [
      {
        hex_value: "#7F4531",
        colour_name: "Sugar Mama",
      },
      {
        hex_value: "#733B2E",
        colour_name: "Bombshell",
      },
      {
        hex_value: "#603838",
        colour_name: "Baby Doll",
      },
      {
        hex_value: "#670C13",
        colour_name: "Bad Girl",
      },
      {
        hex_value: "#512C33",
        colour_name: "Night Walker",
      },
      {
        hex_value: "#1A1929",
        colour_name: "Rebel",
      },
      {
        hex_value: "#071C13",
        colour_name: "Bad Seed",
      },
      {
        hex_value: "#201913",
        colour_name: "Femme Fatale",
      },
    ],
  },
  {
    id: 857,
    brand: "nyx",
    name: "Duo Chromatic Lip Gloss",
    price: "8.0",
    price_sign: "$",
    currency: "USD",
    image_link:
      "https://www.nyxcosmetics.com/dw/image/v2/AANG_PRD/on/demandware.static/-/Sites-cpd-nyxusa-master-catalog/default/dwf51cf9e7/ProductImages/2018/Lips/Duo_Chromatic_Lip_Gloss/duochromaticlipgloss_main.jpg?sw=390&sh=390&sm=fit",
    product_link:
      "https://www.nyxcosmetics.com/duo-chromatic-lip-gloss/NYX_579.html?cgid=lipgloss",
    website_link: "https://www.nyxcosmetics.com",
    description:
      "Want totally mesmerizing lips? Then chrome and get ’em with our brand-new Duo Chromatic Lip Gloss loaded with pearls. These lippies deliver awesome shine, a hint of color and an intense, 3-D finish. Each lightweight shade slips onto your lips smoothly without feeling sticky. Swipe them on alone or over any lipstick for an unforgettable effect.",
    rating: null,
    category: "lip_gloss",
    product_type: "lipstick",
    tag_list: [],
    created_at: "2017-12-24T02:25:55.235Z",
    updated_at: "2017-12-24T02:25:55.925Z",
    product_api_url:
      "https://makeup-api.herokuapp.com/api/v1/products/857.json",
    api_featured_image:
      "//s3.amazonaws.com/donovanbailey/products/api_featured_images/000/000/857/original/open-uri20171224-4-4k5tpf?1514082354",
    product_colors: [
      {
        hex_value: "#CAA6A8",
        colour_name: "The New Normal",
      },
      {
        hex_value: "#E8BBBE",
        colour_name: "Booming",
      },
      {
        hex_value: "#DBACA4",
        colour_name: "Spring It On",
      },
      {
        hex_value: "#E6B06A",
        colour_name: "Cocktail Party",
      },
      {
        hex_value: "#EFA367",
        colour_name: "Fairplay",
      },
      {
        hex_value: "#E0DBD5",
        colour_name: "Crushing It",
      },
      {
        hex_value: "#BE9CAD",
        colour_name: "Gypsy Dream",
      },
      {
        hex_value: "#A8C0C2",
        colour_name: "Day Club",
      },
      {
        hex_value: "#D3CCB9",
        colour_name: "Lucid",
      },
      {
        hex_value: "#A0C6B9",
        colour_name: "Foam Party",
      },
    ],
  },

  {
    id: 994,
    brand: "nyx",
    name: "Double Stacked Mascara",
    price: "15.0",
    price_sign: "$",
    currency: "USD",
    image_link:
      "https://www.nyxcosmetics.com/dw/image/v2/AANG_PRD/on/demandware.static/-/Sites-cpd-nyxusa-master-catalog/default/dw255fbdae/ProductImages/2016/Eyes/Double_Stacked_Mascara/doublestackedmascara_main.jpg?sw=390&sh=390&sm=fit",
    product_link:
      "https://www.nyxcosmetics.com/double-stacked-mascara/NYX_341.html?cgid=mascara",
    website_link: "https://www.nyxcosmetics.com",
    description: "",
    rating: null,
    category: null,
    product_type: "mascara",
    tag_list: [],
    created_at: "2017-12-24T02:33:05.545Z",
    updated_at: "2017-12-24T02:33:05.848Z",
    product_api_url:
      "https://makeup-api.herokuapp.com/api/v1/products/994.json",
    api_featured_image:
      "//s3.amazonaws.com/donovanbailey/products/api_featured_images/000/000/994/original/open-uri20171224-4-1shcfum?1514082785",
    product_colors: [],
  },
  {
    id: 475,
    brand: null,
    name: "Fake Bake Blush Legal Sunburn",
    price: "15.99",
    price_sign: null,
    currency: null,
    image_link:
      "https://d3t32hsnjxo7q6.cloudfront.net/i/a20f3622d08d7b87492ca0af0319bf73_ra,w158,h184_pa,w158,h184.jpg",
    product_link:
      "https://well.ca/products/fake-bake-blush-legal-sunburn_103989.html",
    website_link: "https://well.ca",
    description:
      "Give your cheeks a sun kissed glow with Fake Bake Blush in Legal Sunburn. Paraben Free. Brush the powder blush over your cheeks, nose, and brow arches, and instantly wake up a tired or pale face.\nThe naturally derived red and pink hues give you a fresh, sexy color-minus the skin damage.Ingredients: Mica, Talc, Nylon-12, Ethylhexyl Palmitate, Parafinum Liquidum, Petrolatum, Kaolin, Magnesium Stearate, Tocopheryl Acetate, Caprylic/Capric, Triglyceride, Silica, Phenoxyethanol, Proctone Olamine, [may contain ( +/-): C!75470, CI77891, CI77499, CI45410:2, CI77492, CI19140:1]",
    rating: 5,
    category: "powder",
    product_type: "blush",
    tag_list: [],
    created_at: "2016-10-01T18:35:36.689Z",
    updated_at: "2017-12-23T21:08:47.614Z",
    product_api_url:
      "https://makeup-api.herokuapp.com/api/v1/products/475.json",
    api_featured_image:
      "//s3.amazonaws.com/donovanbailey/products/api_featured_images/000/000/475/original/data?1514063327",
    product_colors: [],
  },
  {
    id: 473,
    brand: "covergirl",
    name: "CoverGirl truBLEND Blush in Light Rose",
    price: "13.99",
    price_sign: null,
    currency: null,
    image_link:
      "https://d3t32hsnjxo7q6.cloudfront.net/i/0b8787d62ced45700c0693b869645542_ra,w158,h184_pa,w158,h184.png",
    product_link:
      "https://well.ca/products/covergirl-trublend-blush-in-light_112758.html",
    website_link: "https://well.ca",
    description:
      "Never stop blushing with CoverGirl New truBLEND blush! Features:New marbled baked formulaUltra-blendable and delivers a beautiful, multi-toned result Designed to fit light, medium and deep skin tones alikeHow to Apply: Step 1: Lightly dip brush into blush, then tap or blow off excess powder. Step 2: Next, sweep the blush over and under your cheekbone to create a beautiful, rosy looking flush. ",
    rating: null,
    category: "powder",
    product_type: "blush",
    tag_list: [],
    created_at: "2016-10-01T18:35:34.299Z",
    updated_at: "2017-12-23T21:08:47.473Z",
    product_api_url:
      "https://makeup-api.herokuapp.com/api/v1/products/473.json",
    api_featured_image:
      "//s3.amazonaws.com/donovanbailey/products/api_featured_images/000/000/473/original/open-uri20171223-4-11ptefh?1514063327",
    product_colors: [],
  },
  {
    id: 730,
    brand: "dior",
    name: "\n                            Matte\n                            ",
    price: "20.0",
    price_sign: "£",
    currency: "GBP",
    image_link:
      "https://www.dior.com/beauty/version-5.1432748111912/resize-image/ep/0/214/90/0/v6_packshots_sku_pdg%252FPDG_Y0002959-F000355999.jpg",
    product_link:
      "https://www.dior.com/beauty/en_gb/fragrance-beauty/makeup/nails/nail-lacquers/pr-naillacquers-y0003759_f000375999-couture-colour-long-wear-nail-lacquer.html",
    website_link: "https://www.dior.com",
    description:
      "Discover the new-generation Dior Vernis and its ingenious formula that accentuates the gel effect.",
    rating: null,
    category: null,
    product_type: "nail_polish",
    tag_list: [],
    created_at: "2017-12-03T23:23:26.195Z",
    updated_at: "2017-12-23T20:59:00.800Z",
    product_api_url:
      "https://makeup-api.herokuapp.com/api/v1/products/730.json",
    api_featured_image:
      "//s3.amazonaws.com/donovanbailey/products/api_featured_images/000/000/730/original/data?1514062740",
    product_colors: [
      {
        hex_value: "#F39994",
        colour_name: "162 Miss Satin",
      },
      {
        hex_value: "#C78377",
        colour_name: "614 Jungle Matte",
      },
      {
        hex_value: "#6D1724",
        colour_name: "979 Poison Metal",
      },
      {
        hex_value: "#A50809",
        colour_name: "999 Matte",
      },
    ],
  },
  {
    id: 156,
    brand: "moov",
    name: "Moov Cosmetics Home Grown Canuck Collection",
    price: "14.99",
    price_sign: null,
    currency: null,
    image_link:
      "https://d3t32hsnjxo7q6.cloudfront.net/i/65ca894afba3c4351a3db71c24234c50_ra,w158,h184_pa,w158,h184.jpg",
    product_link:
      "https://well.ca/products/moov-cosmetics-home-grown-canuck_116061.html",
    website_link: "https://well.ca",
    description:
      "The Moov Cosmetics Home Grown Canuck Collection is a vegan nail colour that has a fun representation of shades from East to West.Features:VeganLonger lasting wearCreamy applicationDirections: Apply two coats, best results with Moov 2-in-1 Prime & Prep application.Ingredients: Butyl Acetate, Ethyl Acetate, Nitrocellulose, Adipic Acid/Neopentyl, Gloycol/Trimellitic Anhydride, Copolymer, Tributyl Citrate, Isopropyl Alcohol, Strearalkonium Bentonite, Acrylates Copolymer, Silica,Benzophenone-1, Trimethylpentanediyl DibenzoateNatural, Vegan, Gluten Free, Fair Trade, Sugar Free, Non-GMO, Dairy Free",
    rating: 3,
    category: null,
    product_type: "nail_polish",
    tag_list: [
      "Natural",
      "Vegan",
      "Gluten Free",
      "Fair Trade",
      "Sugar Free",
      "Non-GMO",
      "Dairy Free",
      "Canadian",
    ],
    created_at: "2016-10-01T18:27:19.853Z",
    updated_at: "2017-12-23T20:51:11.135Z",
    product_api_url:
      "https://makeup-api.herokuapp.com/api/v1/products/156.json",
    api_featured_image:
      "//s3.amazonaws.com/donovanbailey/products/api_featured_images/000/000/156/original/data?1514062271",
    product_colors: [
      {
        hex_value: "#251414",
        colour_name: "Deep Creek ",
      },
      {
        hex_value: "#521B3E",
        colour_name: "Canadian Wildberries ",
      },
      {
        hex_value: "#A99483",
        colour_name: "Double Double ",
      },
      {
        hex_value: "#C4658F",
        colour_name: "Lunching In Yorkville ",
      },
      {
        hex_value: "#8C0002",
        colour_name: "True North ",
      },
    ],
  },
  {
    id: 154,
    brand: "l'oreal",
    name: "L'Oreal Infallible Nail Polish in Irresistible Bonbon",
    price: "10.99",
    price_sign: null,
    currency: null,
    image_link:
      "https://d3t32hsnjxo7q6.cloudfront.net/i/69ca8bd686b0c24e44a2033f4aacf035_ra,w158,h184_pa,w158,h184.jpg",
    product_link:
      "https://well.ca/products/loreal-infallible-nail-polish-in_102190.html",
    website_link: "https://well.ca",
    description:
      "L'Oreal Infallible Nail Polish gives you fantastic gel-like nail colour with a tinted top coat to match!This Infallible nail polish has an exclusive hybrid combo of silicone and Flex-Resin™ that \ninteract with one another to create a unique matrix. The formulas are a \ncombination of film forming polymer, gellifying agents and crystal \ncopolymer designed to bring durability, adhesion to nail and brilliant \nshine. Provides a smooth, plump, spectacular gel shine manicure that \nlasts.Features: Up to 12-day wear\nSpectacular gel shine\nMatching tinted top coat\nNo nail damage\nEasy to remove",
    rating: null,
    category: null,
    product_type: "nail_polish",
    tag_list: [],
    created_at: "2016-10-01T18:27:15.795Z",
    updated_at: "2017-12-23T20:51:10.631Z",
    product_api_url:
      "https://makeup-api.herokuapp.com/api/v1/products/154.json",
    api_featured_image:
      "//s3.amazonaws.com/donovanbailey/products/api_featured_images/000/000/154/original/data?1514062270",
    product_colors: [],
  },
  {
    id: 153,
    brand: "orly",
    name: "Orly EPIX Flexible Sealcoat",
    price: "13.49",
    price_sign: null,
    currency: null,
    image_link:
      "https://d3t32hsnjxo7q6.cloudfront.net/i/648283e42d7fafb7c03e8c60274cd5e0_ra,w158,h184_pa,w158,h184.png",
    product_link:
      "https://well.ca/products/orly-epix-flexible-sealcoat_106342.html?cat=678",
    website_link: "https://well.ca",
    description:
      "Orly introduces the next big thing in the industry. EPIX Flexible Color is a 2 step manicure system that has a long wearing formula with smudge-fixing technology.Features:Dries faster - in less than 8 minutesLasts longer - over a weekInnovative Smudge-Fixing Technology allows the formula to remain elastic and flex with the nail, making smudges and chips a thing of the pastApplies easily and removes like a polishNew Custom 600 Bristle Count Brush Technology and Gripper Cap provide precise application and even coverage on the nailDelivers a high shine finishHow Does it Work?Step 1 Flexible Colour: Begin by performing a dry manicure. Lightly buff nails and clean nail surface with alcohol.  Apply an even coat of EPIX Flexible Color to all ten nails.  Apply a second coat for full coverageStep 2 Flexible Sealcoat: Finish with 1 coat of EPIX Flexible Sealcoat to seal in color and shine.  For extended wear, reapply Sealcoat after three days.* Smudges will continue to self-repair until the Flexible Color is fully dry.",
    rating: 5,
    category: null,
    product_type: "nail_polish",
    tag_list: [],
    created_at: "2016-10-01T18:27:14.218Z",
    updated_at: "2017-12-23T20:51:10.492Z",
    product_api_url:
      "https://makeup-api.herokuapp.com/api/v1/products/153.json",
    api_featured_image:
      "//s3.amazonaws.com/donovanbailey/products/api_featured_images/000/000/153/original/open-uri20171223-4-snvley?1514062270",
    product_colors: [],
  },
  {
    id: 926,
    brand: "nyx",
    name: "Matte Bronzer",
    price: "9.0",
    price_sign: "$",
    currency: "USD",
    image_link:
      "https://www.nyxcosmetics.com/dw/image/v2/AANG_PRD/on/demandware.static/-/Sites-cpd-nyxusa-master-catalog/default/dwed153ea9/ProductImages/Face/Matte_Bronzer/800897809058_mattebronzer_light_main.jpg?sw=390&sh=390&sm=fit",
    product_link:
      "https://www.nyxcosmetics.com/matte-bronzer/NYX_063.html?cgid=bronzer",
    website_link: "https://www.nyxcosmetics.com",
    description:
      "Perfect for Spring Summer and beyond – the Matte Bronzers have arrived! Achieve a natural and healthy looking complexion using any of the powder bronzers available in five russet shades. Perfect for that desired honey glow all year long!",
    rating: null,
    category: null,
    product_type: "bronzer",
    tag_list: [],
    created_at: "2017-12-24T02:28:51.848Z",
    updated_at: "2017-12-24T02:30:56.462Z",
    product_api_url:
      "https://makeup-api.herokuapp.com/api/v1/products/926.json",
    api_featured_image:
      "//s3.amazonaws.com/donovanbailey/products/api_featured_images/000/000/926/original/open-uri20171224-4-6mx0la?1514082656",
    product_colors: [
      {
        hex_value: "#C58965",
        colour_name: "Light",
      },
      {
        hex_value: "#AC7D63",
        colour_name: "Deep",
      },
      {
        hex_value: "#BB805E",
        colour_name: "Medium",
      },
      {
        hex_value: "#B27759",
        colour_name: "Dark Tan",
      },
      {
        hex_value: "#B17752",
        colour_name: "Deep Tan",
      },
    ],
  },

  {
    id: 968,
    brand: "nyx",
    name: "Cake That! Powder Eyeliner",
    price: "8.0",
    price_sign: "$",
    currency: "USD",
    image_link:
      "https://www.nyxcosmetics.com/dw/image/v2/AANG_PRD/on/demandware.static/-/Sites-cpd-nyxusa-master-catalog/default/dwb7f857fa/ProductImages/2017/Eyes/Cake_That_Powder_Eyeliner/cakethatpowdereyeliner_main.jpg?sw=390&sh=390&sm=fit",
    product_link:
      "https://www.nyxcosmetics.com/cake-that-powder-eyeliner/NYX_448.html?cgid=eyeliner",
    website_link: "https://www.nyxcosmetics.com",
    description: "",
    rating: null,
    category: "cream",
    product_type: "eyeliner",
    tag_list: [],
    created_at: "2017-12-24T02:32:29.030Z",
    updated_at: "2017-12-24T02:32:29.408Z",
    product_api_url:
      "https://makeup-api.herokuapp.com/api/v1/products/968.json",
    api_featured_image:
      "//s3.amazonaws.com/donovanbailey/products/api_featured_images/000/000/968/original/open-uri20171224-4-159mdg6?1514082748",
    product_colors: [],
  },
  {
    id: 967,
    brand: "nyx",
    name: "Epic Black Mousse Liner",
    price: "10.0",
    price_sign: "$",
    currency: "USD",
    image_link:
      "https://www.nyxcosmetics.com/dw/image/v2/AANG_PRD/on/demandware.static/-/Sites-cpd-nyxusa-master-catalog/default/dw1f473566/ProductImages/Eyes/Epic_Black_Mousse_Liner/800897832162_epicblackmousseliner_main.jpg?sw=390&sh=390&sm=fit",
    product_link:
      "https://www.nyxcosmetics.com/epic-black-mousse-liner/NYX_158.html?cgid=eyeliner",
    website_link: "https://www.nyxcosmetics.com",
    description:
      "Amazingly fluffy and lightweight, our innovative Epic Black Mousse Liner glides on oh-so-soft and smooth! This waterproof eyeliner dries to a pigmented matte finish that looks totally EPIC.",
    rating: null,
    category: "cream",
    product_type: "eyeliner",
    tag_list: [],
    created_at: "2017-12-24T02:32:28.161Z",
    updated_at: "2017-12-24T02:32:28.770Z",
    product_api_url:
      "https://makeup-api.herokuapp.com/api/v1/products/967.json",
    api_featured_image:
      "//s3.amazonaws.com/donovanbailey/products/api_featured_images/000/000/967/original/data?1514082747",
    product_colors: [],
  },
  {
    id: 966,
    brand: "nyx",
    name: "Cosmic Gel Liner",
    price: "10.0",
    price_sign: "$",
    currency: "USD",
    image_link:
      "https://www.nyxcosmetics.com/dw/image/v2/AANG_PRD/on/demandware.static/-/Sites-cpd-nyxusa-master-catalog/default/dw62a7d3b0/ProductImages/2016/Eyes/Cosmic_Gel_Liner/800897016364_cosmicgelliner_interstellar_main.jpg?sw=390&sh=390&sm=fit",
    product_link:
      "https://www.nyxcosmetics.com/cosmic-gel-liner/NYX_335.html?cgid=eyeliner",
    website_link: "https://www.nyxcosmetics.com",
    description:
      "Swap your standard wing for eyes that twinkle like stars! A beam of Cosmic Gel Eye Liner makes an out of this world statement through an intense burst of sparkle and bold color. Available in three shades packed with interstellar shimmer, this formula glides on silky-smooth and is super easy to blend. Like our fan fave Gel Liner and Smudger, these rich colors stay put for strong galactic glam.",
    rating: null,
    category: "gel",
    product_type: "eyeliner",
    tag_list: [],
    created_at: "2017-12-24T02:32:26.896Z",
    updated_at: "2017-12-24T02:32:27.267Z",
    product_api_url:
      "https://makeup-api.herokuapp.com/api/v1/products/966.json",
    api_featured_image:
      "//s3.amazonaws.com/donovanbailey/products/api_featured_images/000/000/966/original/open-uri20171224-4-kpqxp4?1514082746",
    product_colors: [
      {
        hex_value: "#D64262",
        colour_name: "Interstellar",
      },
      {
        hex_value: "#06ADE4",
        colour_name: "Supernatural",
      },
      {
        hex_value: "#262B51",
        colour_name: "Infinite Star",
      },
    ],
  },
  {
    id: 965,
    brand: "nyx",
    name: "Gel Liner And Smudger",
    price: "9.0",
    price_sign: "$",
    currency: "USD",
    image_link:
      "https://www.nyxcosmetics.com/dw/image/v2/AANG_PRD/on/demandware.static/-/Sites-cpd-nyxusa-master-catalog/default/dw7fa3d736/ProductImages/Eyes/Gel_Liner_And_Smudger/gellinerandsmudger_main.jpg?sw=390&sh=390&sm=fit",
    product_link:
      "https://www.nyxcosmetics.com/gel-liner-and-smudger/NYX_080.html?cgid=eyeliner",
    website_link: "https://www.nyxcosmetics.com",
    description:
      "Our Gel Liner & Smudger delivers bold color that won’t quit. Whether you’re after a perfectly defined line or a smokey eye, these silky shades blend easily and don’t crease or fade. This pigmented formula is now available in two brand new shades.",
    rating: null,
    category: "gel",
    product_type: "eyeliner",
    tag_list: [],
    created_at: "2017-12-24T02:32:25.619Z",
    updated_at: "2017-12-24T02:32:25.974Z",
    product_api_url:
      "https://makeup-api.herokuapp.com/api/v1/products/965.json",
    api_featured_image:
      "//s3.amazonaws.com/donovanbailey/products/api_featured_images/000/000/965/original/open-uri20171224-4-8mqi9p?1514082745",
    product_colors: [
      {
        hex_value: "#E8E7E3",
        colour_name: "Emma",
      },
      {
        hex_value: "#444444",
        colour_name: "Betty",
      },
      {
        hex_value: "#725C47",
        colour_name: "Charlotte",
      },
      {
        hex_value: "#03C7B9",
        colour_name: "Danielle",
      },
      {
        hex_value: "#496CBE",
        colour_name: "Samantha",
      },
      {
        hex_value: "#512F16",
        colour_name: "Scarlette",
      },
      {
        hex_value: "#583668",
        colour_name: "Annie",
      },
    ],
  },
  {
    id: 856,
    brand: "nyx",
    name: "Slip Tease Full Color Lip Oil",
    price: "7.0",
    price_sign: "$",
    currency: "USD",
    image_link:
      "https://www.nyxcosmetics.com/dw/image/v2/AANG_PRD/on/demandware.static/-/Sites-cpd-nyxusa-master-catalog/default/dwd377cdfa/ProductImages/2017/Lips/Slip_Tease_Full_Color_Lip_Oil/slipteasefullcolorlipoil_main.jpg?sw=390&sh=390&sm=fit",
    product_link:
      "https://www.nyxcosmetics.com/slip-tease-full-color-lip-oil/NYX_444.html?cgid=lipgloss",
    website_link: "https://www.nyxcosmetics.com",
    description: "",
    rating: null,
    category: "lip_gloss",
    product_type: "lipstick",
    tag_list: [],
    created_at: "2017-12-24T02:25:52.691Z",
    updated_at: "2017-12-24T02:26:11.159Z",
    product_api_url:
      "https://makeup-api.herokuapp.com/api/v1/products/856.json",
    api_featured_image:
      "//s3.amazonaws.com/donovanbailey/products/api_featured_images/000/000/856/original/open-uri20171224-4-n7nifg?1514082369",
    product_colors: [
      {
        hex_value: "#D7978E",
        colour_name: "I Woke Up Like This",
      },
      {
        hex_value: "#B98180",
        colour_name: "Entice",
      },
      {
        hex_value: "#D87884",
        colour_name: "Coy",
      },
      {
        hex_value: "#8B4B4C",
        colour_name: "Bang Bang",
      },
      {
        hex_value: "#FF56A8",
        colour_name: "Baecation",
      },
      {
        hex_value: "#B73E8D",
        colour_name: "Fatal Attraction",
      },
      {
        hex_value: "#974AB4",
        colour_name: "Feisty",
      },
      {
        hex_value: "#BD6A66",
        colour_name: "Lowkey",
      },
      {
        hex_value: "#921736",
        colour_name: "Fire Dancer",
      },
      {
        hex_value: "#A1745D",
        colour_name: "Beyond Basic",
      },
      {
        hex_value: "#D3212F",
        colour_name: "Red Queen",
      },
      {
        hex_value: "#FF6964",
        colour_name: "Breezy",
      },
    ],
  },
  {
    id: 855,
    brand: "nyx",
    name: "Liquid Suede Metallic Matte",
    price: "7.5",
    price_sign: "$",
    currency: "USD",
    image_link:
      "https://www.nyxcosmetics.com/dw/image/v2/AANG_PRD/on/demandware.static/-/Sites-cpd-nyxusa-master-catalog/default/dw9d2f72a4/ProductImages/2017/Lips/Liquid_Suede_Metallic_Matte/liquidsuedemetallicmatte_main.jpg?sw=390&sh=390&sm=fit",
    product_link:
      "https://www.nyxcosmetics.com/liquid-suede-metallic-matte/NYX_441.html?cgid=lipstick",
    website_link: "https://www.nyxcosmetics.com",
    description:
      "Wrap your lips in high-impact metallic color with Liquid Suede Metallic Matte, a striking new lip inspired by our best-selling Liquid Suede Cream Lipstick. Available in 12 statement-making shades, these shockingly creamy lippies deliver instant dimension and incredible color payoff. In other words, get ready to slay.",
    rating: null,
    category: "lipstick",
    product_type: "lipstick",
    tag_list: [],
    created_at: "2017-12-24T02:25:49.754Z",
    updated_at: "2017-12-24T02:26:23.322Z",
    product_api_url:
      "https://makeup-api.herokuapp.com/api/v1/products/855.json",
    api_featured_image:
      "//s3.amazonaws.com/donovanbailey/products/api_featured_images/000/000/855/original/open-uri20171224-4-10m51gg?1514082383",
    product_colors: [
      {
        hex_value: "#BC7D5A",
        colour_name: "Exposed",
      },
      {
        hex_value: "#9A4F3C",
        colour_name: "Mauve Mist",
      },
      {
        hex_value: "#9C3E3C",
        colour_name: "Bella",
      },
      {
        hex_value: "#82412B",
        colour_name: "New Era",
      },
      {
        hex_value: "#563428",
        colour_name: "Neat Nude",
      },
      {
        hex_value: "#A91851",
        colour_name: "Buzzkill",
      },
      {
        hex_value: "#9E1F26",
        colour_name: "Acme",
      },
      {
        hex_value: "#7A253A",
        colour_name: "Modern Maven",
      },
      {
        hex_value: "#761538",
        colour_name: "Pure Society",
      },
      {
        hex_value: "#752329",
        colour_name: "Biker Babe",
      },
      {
        hex_value: "#472071",
        colour_name: "Ego",
      },
      {
        hex_value: "#2F3239",
        colour_name: "Go Rogue",
      },
    ],
  },
  {
    id: 854,
    brand: "nyx",
    name: "Liquid Suede Cream Lipstick",
    price: "7.0",
    price_sign: "$",
    currency: "USD",
    image_link:
      "https://www.nyxcosmetics.com/dw/image/v2/AANG_PRD/on/demandware.static/-/Sites-cpd-nyxusa-master-catalog/default/dwa19d7c26/ProductImages/Lips/Liquid_Suede_Cream_Lipstick/liquidsuedecreamlipstick_main.jpg?sw=390&sh=390&sm=fit",
    product_link:
      "https://www.nyxcosmetics.com/liquid-suede-cream-lipstick/NYX_201.html?cgid=lipstick",
    website_link: "https://www.nyxcosmetics.com",
    description:
      "Doll up your lips in plush and vibrant color! Our Liquid Suede Cream Lipstick glides on and sets into a striking matte finish. Now available in 12 more velvety-soft shades, this waterproof lippie creates a positively polished look with every swipe.",
    rating: null,
    category: "lipstick",
    product_type: "lipstick",
    tag_list: [],
    created_at: "2017-12-24T02:25:46.851Z",
    updated_at: "2017-12-24T02:26:39.313Z",
    product_api_url:
      "https://makeup-api.herokuapp.com/api/v1/products/854.json",
    api_featured_image:
      "//s3.amazonaws.com/donovanbailey/products/api_featured_images/000/000/854/original/open-uri20171224-4-seihwb?1514082398",
    product_colors: [
      {
        hex_value: "#DF666F",
        colour_name: "Tea & Cookies",
      },
      {
        hex_value: "#FE5862",
        colour_name: "Life's A Beach",
      },
      {
        hex_value: "#FC3183",
        colour_name: "Pink Lust",
      },
      {
        hex_value: "#CD060B",
        colour_name: "Kitten Heels",
      },
      {
        hex_value: "#962A27",
        colour_name: "Cherry Skies",
      },
      {
        hex_value: "#FD7136",
        colour_name: "Foiled Again",
      },
      {
        hex_value: "#FC5221",
        colour_name: "Orange County",
      },
      {
        hex_value: "#01A3E3",
        colour_name: "Little Denim Dress",
      },
      {
        hex_value: "#2F2A88",
        colour_name: "Jet Set",
      },
      {
        hex_value: "#3A1C66",
        colour_name: "Foul Mouth",
      },
      {
        hex_value: "#DE65B2",
        colour_name: "Respect The Pink",
      },
      {
        hex_value: "#BE61B1",
        colour_name: "Sway",
      },
      {
        hex_value: "#A03FA0",
        colour_name: "Run The World",
      },
      {
        hex_value: "#6D2686",
        colour_name: "Amethyst",
      },
      {
        hex_value: "#5A2253",
        colour_name: "Subversive Socialite",
      },
      {
        hex_value: "#3B1153",
        colour_name: "Oh, Put It On",
      },
      {
        hex_value: "#7B2D3B",
        colour_name: "Vintage",
      },
      {
        hex_value: "#722F26",
        colour_name: "Club Hopper",
      },
      {
        hex_value: "#AA614E",
        colour_name: "Sandstorm",
      },
      {
        hex_value: "#AE5350",
        colour_name: "Soft-Spoken",
      },
      {
        hex_value: "#815049",
        colour_name: "Brooklyn Thorn",
      },
      {
        hex_value: "#7E5036",
        colour_name: "Downtown Beauty",
      },
      {
        hex_value: "#585455",
        colour_name: "Stone Fox",
      },
      {
        hex_value: "#2A2829",
        colour_name: "Alien",
      },
    ],
  },
  {
    id: 853,
    brand: "nyx",
    name: "Lip Lingerie",
    price: "7.0",
    price_sign: "$",
    currency: "USD",
    image_link:
      "https://www.nyxcosmetics.com/dw/image/v2/AANG_PRD/on/demandware.static/-/Sites-cpd-nyxusa-master-catalog/default/dw00c7446b/ProductImages/2017/Lips/Lip_Lingerie_Extension/liplingerie_main.jpg?sw=390&sh=390&sm=fit",
    product_link:
      "https://www.nyxcosmetics.com/lip-lingerie/NYX_315.html?cgid=lipstick",
    website_link: "https://www.nyxcosmetics.com",
    description:
      "Slip into something seductive with Lip Lingerie, our luxurious liquid lipstick with a plush, Matte finish. Available in the color-kissed hues you know and love—from cinnamon pink and chocolate brown, to warm mahogany red and classic nude beige—plus, 12 brand-new nudes! Each sultry shade will coat the curves of your lips with irresistibly creamy color.",
    rating: null,
    category: "lipstick",
    product_type: "lipstick",
    tag_list: [],
    created_at: "2017-12-24T02:25:43.772Z",
    updated_at: "2017-12-24T02:26:27.212Z",
    product_api_url:
      "https://makeup-api.herokuapp.com/api/v1/products/853.json",
    api_featured_image:
      "//s3.amazonaws.com/donovanbailey/products/api_featured_images/000/000/853/original/open-uri20171224-4-107hboe?1514082386",
    product_colors: [
      {
        hex_value: "#F8AB8F",
        colour_name: "Cheekies",
      },
      {
        hex_value: "#E59886",
        colour_name: "Silk Indulgent",
      },
      {
        hex_value: "#C48B7A",
        colour_name: "Baby Doll",
      },
      {
        hex_value: "#C38878",
        colour_name: "Lace Detail",
      },
      {
        hex_value: "#B77E6B",
        colour_name: "Push-Up",
      },
      {
        hex_value: "#AF7260",
        colour_name: "Bedtime Flirt",
      },
      {
        hex_value: "#AF7079",
        colour_name: "Embellishment",
      },
      {
        hex_value: "#BF7D6F",
        colour_name: "Cashmere Silk",
      },
      {
        hex_value: "#A9796F",
        colour_name: "Bustier",
      },
      {
        hex_value: "#A76169",
        colour_name: "French Maid",
      },
      {
        hex_value: "#704D47",
        colour_name: "Confident",
      },
      {
        hex_value: "#903E33",
        colour_name: "Exotic",
      },
      {
        hex_value: "#A25A4E",
        colour_name: "Cabaret Show",
      },
      {
        hex_value: "#C46954",
        colour_name: "Seduction",
      },
      {
        hex_value: "#C07764",
        colour_name: "Ruffle Trim",
      },
      {
        hex_value: "#E29871",
        colour_name: "Dusk To Dawn",
      },
      {
        hex_value: "#C59581",
        colour_name: "Satin Ribbon",
      },
      {
        hex_value: "#C0947B",
        colour_name: "Corset",
      },
      {
        hex_value: "#966F60",
        colour_name: "Delicate Lust",
      },
      {
        hex_value: "#96705D",
        colour_name: "Honeymoon",
      },
      {
        hex_value: "#8F624D",
        colour_name: "Teddy",
      },
      {
        hex_value: "#8B5845",
        colour_name: "After Hours",
      },
      {
        hex_value: "#855A4A",
        colour_name: "Beauty Mark",
      },
      {
        hex_value: "#715E50",
        colour_name: "Scandalous",
      },
    ],
  },
  {
    id: 912,
    brand: "nyx",
    name: "Gotcha Covered Concealer Pencil",
    price: "7.0",
    price_sign: "$",
    currency: "USD",
    image_link:
      "https://www.nyxcosmetics.com/dw/image/v2/AANG_PRD/on/demandware.static/-/Sites-cpd-nyxusa-master-catalog/default/dw8ad0514f/ProductImages/2016/Face/Gotcha_Covered_Concealer_Pencil/gotchacoveredconcealerpencil_main.jpg?sw=390&sh=390&sm=fit",
    product_link:
      "https://www.nyxcosmetics.com/gotcha-covered-concealer-pencil/NYX_346.html?cgid=concealer",
    website_link: "https://www.nyxcosmetics.com",
    description:
      "Skin imperfections, beware! When it comes to covering up discoloration, our new Gotcha Covered Concealer Pencil does NOT mess around. Available in 20 blendable shades, this luxurious concealer is a master at spot concealing.",
    rating: null,
    category: "concealer",
    product_type: "foundation",
    tag_list: [],
    created_at: "2017-12-24T02:28:21.007Z",
    updated_at: "2017-12-24T02:30:17.143Z",
    product_api_url:
      "https://makeup-api.herokuapp.com/api/v1/products/912.json",
    api_featured_image:
      "//s3.amazonaws.com/donovanbailey/products/api_featured_images/000/000/912/original/open-uri20171224-4-abiui6?1514082616",
    product_colors: [
      {
        hex_value: "#F8DFC0",
        colour_name: "Alabaster",
      },
      {
        hex_value: "#F3D0B2",
        colour_name: "Light Ivory",
      },
      {
        hex_value: "#EFCBB1",
        colour_name: "Ivory",
      },
      {
        hex_value: "#EDC7A2",
        colour_name: "Light",
      },
      {
        hex_value: "#DDB997",
        colour_name: "Nude Beige",
      },
      {
        hex_value: "#DCBA97",
        colour_name: "Medium Olive",
      },
      {
        hex_value: "#DBB795",
        colour_name: "Honey Beige",
      },
      {
        hex_value: "#DDB174",
        colour_name: "Caramel Beige",
      },
      {
        hex_value: "#D7A568",
        colour_name: "Classic Tan",
      },
      {
        hex_value: "#D1A278",
        colour_name: "Golden",
      },
      {
        hex_value: "#CB9A6F",
        colour_name: "Sand",
      },
      {
        hex_value: "#B9884D",
        colour_name: "Deep Golden",
      },
      {
        hex_value: "#AA5E2A",
        colour_name: "Mahogany",
      },
      {
        hex_value: "#804F31",
        colour_name: "Cappuccino",
      },
      {
        hex_value: "#7B5236",
        colour_name: "Cocoa",
      },
      {
        hex_value: "#69442A",
        colour_name: "Deep Rich",
      },
      {
        hex_value: "#673C2B",
        colour_name: "Espresso",
      },
      {
        hex_value: "#653A29",
        colour_name: "Deep Espresso",
      },
      {
        hex_value: "#F4D1B3",
        colour_name: "Beige",
      },
    ],
  },
  {
    id: 911,
    brand: "nyx",
    name: "Conceal, Correct, Contour Palette",
    price: "12.0",
    price_sign: "$",
    currency: "USD",
    image_link:
      "https://www.nyxcosmetics.com/dw/image/v2/AANG_PRD/on/demandware.static/-/Sites-cpd-nyxusa-master-catalog/default/dwbef45c94/ProductImages/Face/Conceal_Correct_Contour_Palette/800897831479_concealcorrectcontourpalette_light_main.jpg?sw=390&sh=390&sm=fit",
    product_link:
      "https://www.nyxcosmetics.com/conceal-correct-contour-palette/NYX_170.html?cgid=concealer",
    website_link: "https://www.nyxcosmetics.com",
    description:
      "Color-match your skin using our perfecting and correcting palettes to conceal, correct, or contour. With six shades to choose from in each set you can cover up problem spots even out imperfections and accentuate your best features in a flash. Use these buildable colors on their own or combine them to create the ideal tone.",
    rating: null,
    category: "concealer",
    product_type: "foundation",
    tag_list: [],
    created_at: "2017-12-24T02:28:19.928Z",
    updated_at: "2017-12-24T02:30:15.919Z",
    product_api_url:
      "https://makeup-api.herokuapp.com/api/v1/products/911.json",
    api_featured_image:
      "//s3.amazonaws.com/donovanbailey/products/api_featured_images/000/000/911/original/open-uri20171224-4-lx4vmq?1514082615",
    product_colors: [
      {
        hex_value: "#FFFEFC",
        colour_name: "Light",
      },
      {
        hex_value: "#FDF9F6",
        colour_name: "Medium",
      },
      {
        hex_value: "#F1F2F4",
        colour_name: "Deep",
      },
    ],
  },
  {
    id: 909,
    brand: "nyx",
    name: "Dark Circle Concealer",
    price: "6.0",
    price_sign: "$",
    currency: "USD",
    image_link:
      "https://www.nyxcosmetics.com/dw/image/v2/AANG_PRD/on/demandware.static/-/Sites-cpd-nyxusa-master-catalog/default/dw477d3d9a/ProductImages/Face/Dark_Circle_Concealer/800897822958_darkcircleconcealer_light_main.jpg?sw=390&sh=390&sm=fit",
    product_link:
      "https://www.nyxcosmetics.com/dark-circle-concealer/NYX_133.html?cgid=concealer",
    website_link: "https://www.nyxcosmetics.com",
    description:
      "A serious solution for one of beauty’s most challenging problems! No fancy names just a product that can be counted on to do the job. The product glides on without looking thick or obvious. The subtle hint of orange counteracts the appearance of dark circles while natural skin-toned pigments work in unison to provide the ultimate coverage.",
    rating: null,
    category: "concealer",
    product_type: "foundation",
    tag_list: [],
    created_at: "2017-12-24T02:28:17.702Z",
    updated_at: "2017-12-24T02:30:13.878Z",
    product_api_url:
      "https://makeup-api.herokuapp.com/api/v1/products/909.json",
    api_featured_image:
      "//s3.amazonaws.com/donovanbailey/products/api_featured_images/000/000/909/original/open-uri20171224-4-vt9rh6?1514082613",
    product_colors: [
      {
        hex_value: "#ECAA87",
        colour_name: "Fair",
      },
      {
        hex_value: "#EA9B70",
        colour_name: "Light",
      },
      {
        hex_value: "#E5895A",
        colour_name: "Medium",
      },
      {
        hex_value: "#A96540",
        colour_name: "Deep",
      },
    ],
  },
  {
    id: 908,
    brand: "nyx",
    name: "Gotcha Covered Concealer",
    price: "6.0",
    price_sign: "$",
    currency: "USD",
    image_link:
      "https://www.nyxcosmetics.com/dw/image/v2/AANG_PRD/on/demandware.static/-/Sites-cpd-nyxusa-master-catalog/default/dw947da0d5/ProductImages/Face/Gotcha_Covered_Concealer/gotchacoveredconcealer_main.jpg?sw=390&sh=390&sm=fit",
    product_link:
      "https://www.nyxcosmetics.com/gotcha-covered-concealer/NYX_203.html?cgid=concealer",
    website_link: "https://www.nyxcosmetics.com",
    description:
      "Gotcha Covered Concealer always has your back! Now available in 10 more gorgeous shades, our waterproof, full coverage concealer effectively covers up discolorations and imperfections without creasing or caking. Infused with coconut oil, this highly blendable concealer also leaves your face with a healthy-looking glow.",
    rating: null,
    category: "concealer",
    product_type: "foundation",
    tag_list: [],
    created_at: "2017-12-24T02:28:15.481Z",
    updated_at: "2017-12-24T02:30:12.047Z",
    product_api_url:
      "https://makeup-api.herokuapp.com/api/v1/products/908.json",
    api_featured_image:
      "//s3.amazonaws.com/donovanbailey/products/api_featured_images/000/000/908/original/open-uri20171224-4-1980tbf?1514082611",
    product_colors: [
      {
        hex_value: "#E9CFB6",
        colour_name: "Alabaster",
      },
      {
        hex_value: "#E7C7AE",
        colour_name: "Ivory",
      },
      {
        hex_value: "#E0C2AA",
        colour_name: "Soft Ivory",
      },
      {
        hex_value: "#D6B79B",
        colour_name: "Light",
      },
      {
        hex_value: "#E0C1A5",
        colour_name: "Natural",
      },
      {
        hex_value: "#DCB18F",
        colour_name: "Beige",
      },
      {
        hex_value: "#D1A77D",
        colour_name: "Medium",
      },
      {
        hex_value: "#CFA984",
        colour_name: "Medium Olive",
      },
      {
        hex_value: "#D5AB81",
        colour_name: "Fresh Beige",
      },
      {
        hex_value: "#C9A37E",
        colour_name: "Golden",
      },
      {
        hex_value: "#B99774",
        colour_name: "Tan",
      },
      {
        hex_value: "#BB906D",
        colour_name: "Sand",
      },
      {
        hex_value: "#B08767",
        colour_name: "Deep Honey",
      },
      {
        hex_value: "#957151",
        colour_name: "Deep",
      },
      {
        hex_value: "#A47C59",
        colour_name: "Cappuccino",
      },
      {
        hex_value: "#997551",
        colour_name: "Deep Caramel",
      },
      {
        hex_value: "#937052",
        colour_name: "Mocha",
      },
      {
        hex_value: "#715138",
        colour_name: "Ebony",
      },
      {
        hex_value: "#72573C",
        colour_name: "Cocoa",
      },
      {
        hex_value: "#5E4433",
        colour_name: "Espresso",
      },
    ],
  },
  {
    id: 907,
    brand: "nyx",
    name: "Color Correcting Palette",
    price: "12.0",
    price_sign: "$",
    currency: "USD",
    image_link:
      "https://www.nyxcosmetics.com/dw/image/v2/AANG_PRD/on/demandware.static/-/Sites-cpd-nyxusa-master-catalog/default/dwb6d96368/ProductImages/Face/Color_Correcting_Palette/800897834722_colorcorrectingpalette_main.jpg?sw=390&sh=390&sm=fit",
    product_link:
      "https://www.nyxcosmetics.com/color-correcting-palette/NYX_171.html?cgid=concealer",
    website_link: "https://www.nyxcosmetics.com",
    description:
      "Treat your face to the ultimate concealer palette in six color correcting shades. Customizable to create your ideal shade to cover imperfections the lightweight formula glides on for an ultra-smooth finish and leaves skin feeling soft and supple.",
    rating: null,
    category: "concealer",
    product_type: "foundation",
    tag_list: [],
    created_at: "2017-12-24T02:28:14.774Z",
    updated_at: "2017-12-24T02:30:11.232Z",
    product_api_url:
      "https://makeup-api.herokuapp.com/api/v1/products/907.json",
    api_featured_image:
      "//s3.amazonaws.com/donovanbailey/products/api_featured_images/000/000/907/original/open-uri20171224-4-1b7ug0q?1514082611",
    product_colors: [],
  },
  {
    id: 906,
    brand: "nyx",
    name: "Concealer Jar",
    price: "5.0",
    price_sign: "$",
    currency: "USD",
    image_link:
      "https://www.nyxcosmetics.com/dw/image/v2/AANG_PRD/on/demandware.static/-/Sites-cpd-nyxusa-master-catalog/default/dw04c31800/ProductImages/Face/Concealer_Jar/concealerjar_main.jpg?sw=390&sh=390&sm=fit",
    product_link:
      "https://www.nyxcosmetics.com/concealer-jar/NYX_011.html?cgid=concealer",
    website_link: "https://www.nyxcosmetics.com",
    description:
      "Obscure imperfections and blur away problem areas with one of our Concealer Jars. Now available in 10 more shades to accommodate an even wider range of skin tones, this creamy formula stands up to the villains of unwelcome imperfections with a vengeance.",
    rating: null,
    category: "concealer",
    product_type: "foundation",
    tag_list: [],
    created_at: "2017-12-24T02:28:11.932Z",
    updated_at: "2017-12-24T02:30:08.254Z",
    product_api_url:
      "https://makeup-api.herokuapp.com/api/v1/products/906.json",
    api_featured_image:
      "//s3.amazonaws.com/donovanbailey/products/api_featured_images/000/000/906/original/open-uri20171224-4-gko26q?1514082608",
    product_colors: [
      {
        hex_value: "#FCDAB5",
        colour_name: "Alabaster",
      },
      {
        hex_value: "#FCCAA5",
        colour_name: "Porcelain",
      },
      {
        hex_value: "#FCCEAD",
        colour_name: "Fair",
      },
      {
        hex_value: "#EFB590",
        colour_name: "Light",
      },
      {
        hex_value: "#DAA677",
        colour_name: "Nude Beige",
      },
      {
        hex_value: "#D9A073",
        colour_name: "Beige",
      },
      {
        hex_value: "#CDA170",
        colour_name: "Sand Beige",
      },
      {
        hex_value: "#CB885E",
        colour_name: "Medium",
      },
      {
        hex_value: "#DB9A74",
        colour_name: "Glow",
      },
      {
        hex_value: "#CC9D69",
        colour_name: "Fresh Beige",
      },
      {
        hex_value: "#D0925F",
        colour_name: "Golden",
      },
      {
        hex_value: "#BC8B50",
        colour_name: "Caramel",
      },
      {
        hex_value: "#BB7B4B",
        colour_name: "Tan",
      },
      {
        hex_value: "#B9743D",
        colour_name: "Deep Golden",
      },
      {
        hex_value: "#A76938",
        colour_name: "Nutmeg",
      },
      {
        hex_value: "#B1703A",
        colour_name: "Cappuccino",
      },
      {
        hex_value: "#A76C40",
        colour_name: "Cocoa",
      },
      {
        hex_value: "#885333",
        colour_name: "Deep Rich",
      },
      {
        hex_value: "#805332",
        colour_name: "Espresso",
      },
      {
        hex_value: "#71482C",
        colour_name: "Deep Espresso",
      },
      {
        hex_value: "#F8D383",
        colour_name: "Yellow",
      },
      {
        hex_value: "#D5BCE6",
        colour_name: "Lavender",
      },
      {
        hex_value: "#BDE0C0",
        colour_name: "Green",
      },
      {
        hex_value: "#FB772F",
        colour_name: "Orange",
      },
    ],
  },
  {
    id: 905,
    brand: "nyx",
    name: "HD Photogenic Concealer Wand",
    price: "5.0",
    price_sign: "$",
    currency: "USD",
    image_link:
      "https://www.nyxcosmetics.com/dw/image/v2/AANG_PRD/on/demandware.static/-/Sites-cpd-nyxusa-master-catalog/default/dw10ab1d12/ProductImages/2016/Face/HD_Photogenic_Concealer_Wand/concealerwand_main.jpg?sw=390&sh=390&sm=fit",
    product_link:
      "https://www.nyxcosmetics.com/hd-photogenic-concealer-wand/NYX_013.html?cgid=concealer",
    website_link: "https://www.nyxcosmetics.com",
    description:
      "Now available in 12 more shades to accommodate an even wider range of skin tones, our best-selling HD Studio Photogenic Concealer effectively covers imperfections, discoloration and under-eye circles without ever looking cakey or obvious. The result is beautiful, natural-looking coverage you can count on.",
    rating: null,
    category: "concealer",
    product_type: "foundation",
    tag_list: [],
    created_at: "2017-12-24T02:28:08.470Z",
    updated_at: "2017-12-24T02:30:04.357Z",
    product_api_url:
      "https://makeup-api.herokuapp.com/api/v1/products/905.json",
    api_featured_image:
      "//s3.amazonaws.com/donovanbailey/products/api_featured_images/000/000/905/original/open-uri20171224-4-1tmsfyh?1514082604",
    product_colors: [
      {
        hex_value: "#EBC7A3",
        colour_name: "Alabaster",
      },
      {
        hex_value: "#ECC3A5",
        colour_name: "Porcelain",
      },
      {
        hex_value: "#EABF9D",
        colour_name: "Fair",
      },
      {
        hex_value: "#E6B897",
        colour_name: "Light",
      },
      {
        hex_value: "#DEB391",
        colour_name: "Nude Beige",
      },
      {
        hex_value: "#DAB08A",
        colour_name: "Beige",
      },
      {
        hex_value: "#D2A67F",
        colour_name: "Sand Beige",
      },
      {
        hex_value: "#D5A080",
        colour_name: "Medium",
      },
      {
        hex_value: "#D49F7D",
        colour_name: "Glow",
      },
      {
        hex_value: "#CD9E74",
        colour_name: "Fresh Beige",
      },
      {
        hex_value: "#CE9872",
        colour_name: "Golden",
      },
      {
        hex_value: "#C5966A",
        colour_name: "Caramel",
      },
      {
        hex_value: "#BE895F",
        colour_name: "Tan",
      },
      {
        hex_value: "#BB8255",
        colour_name: "Deep Golden",
      },
      {
        hex_value: "#B2794C",
        colour_name: "Nutmeg",
      },
      {
        hex_value: "#945D3F",
        colour_name: "Cappuccino",
      },
      {
        hex_value: "#93633F",
        colour_name: "Cocoa",
      },
      {
        hex_value: "#83573E",
        colour_name: "Deep Rich",
      },
      {
        hex_value: "#7C4F38",
        colour_name: "Espresso",
      },
      {
        hex_value: "#6B3E27",
        colour_name: "Deep Espresso",
      },
      {
        hex_value: "#F2CC8E",
        colour_name: "Yellow",
      },
      {
        hex_value: "#BFB3C9",
        colour_name: "Lavender",
      },
      {
        hex_value: "#A0C8AD",
        colour_name: "Green",
      },
    ],
  },
];
